var path = 'areas/projects/action-template-fields/field-SingleLineText.html';
var html = "<div> <input class=form-control type=text ng-model=vm.value placeholder={{vm.placeholder}}> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/action-template-fields/field-SingleLineText.html
// module id = 840
// module chunks = 1